import EllipsisToolTip from "../../../../../../base/basicComponents/ellipsisToolTip";
import { FileStatusDiv } from "../../../../../../base/basicComponents/status";
import UpdateSupportingFileTbody from "../updateSupportingFileTbody";
import { PreviewFileLink } from "app/pages/previewFile";

export default class UpdateSupportingFileModalTbody extends UpdateSupportingFileTbody {
  returnFileName = (rowColumn: any, column: any, row: any) => {
    const popupContainer =
      document.getElementsByClassName("procedureModalFiles")[0] ||
      document.getElementsByClassName("supportingModalFiles")[0];
    return (
      <div className="fileNameContainer">
        <EllipsisToolTip
          children={
            <PreviewFileLink
              fileId={row.data.find((i: any) => i.name === "fileId").value}
              fileName={rowColumn.value}
            >
              {rowColumn.value}
            </PreviewFileLink>
          }
          title={rowColumn.value}
          placement="top"
          getPopupContainer={() => popupContainer}
        />
        {rowColumn.tagValue !== null && <FileStatusDiv status={rowColumn.tagValue} />}
      </div>
    );
  };
}
